import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["title", "strong", "description", "actions", "Icon", "handleClose", "children"];
import _parseInt from "@babel/runtime-corejs3/core-js-stable/parse-int";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState } from 'react';
import Box from '@rexlabs/box';
import { useStyles, useToken, StyleSheet, text, border, margin, icon } from '@rexlabs/styling';
import { OutlineButton, TintIconButton, ButtonGroup, GhostButton } from '@rexlabs/button';
import { useResizeObserver } from '@rexlabs/react-hooks';
import Icons from '@rexlabs/icons';
var CrossSmall = Icons.CrossSmall;
var defaultStyles = StyleSheet({
  container: _objectSpread(_objectSpread({}, border.styles({
    target: 'banner',
    all: {
      width: 'thin',
      radius: 'l',
      color: 'container.static.light'
    }
  })), {}, {
    width: function width(_ref) {
      var token = _ref.token;
      return token('banner.width', '100%');
    },
    maxWidth: function maxWidth(_ref2) {
      var token = _ref2.token;
      return token('banner.maxWidth');
    },
    backgroundColor: function backgroundColor(_ref3) {
      var token = _ref3.token;
      return token('banner.background.color', token('color.container.static.default'));
    },
    boxShadow: function boxShadow(_ref4) {
      var token = _ref4.token;
      return token('banner.boxShadow');
    }
  }),
  strong: _objectSpread(_objectSpread(_objectSpread({}, text.styles({
    target: 'banner.strong'
  })), border.styles({
    target: 'banner.strong',
    all: {
      color: 'container.static.dark'
    }
  })), {}, {
    backgroundColor: function backgroundColor(_ref5) {
      var token = _ref5.token;
      return token('banner.strong.background.color', token('color.container.static.dark'));
    }
  }),
  icon: {
    height: function height(_ref6) {
      var token = _ref6.token;
      return token('banner.description.lineHeight', token('textStyle.normal.default.lineHeight'));
    },
    '& > svg': _objectSpread({}, icon.styles({
      target: 'banner.icon',
      size: 'm'
    }))
  },
  title: _objectSpread(_objectSpread({
    wordBreak: 'break-word'
  }, text.styles({
    target: 'banner.title',
    fallback: 'normal.bold'
  })), margin.styles({
    target: 'banner.title',
    right: 's'
  })),
  description: _objectSpread(_objectSpread({
    wordBreak: 'break-word'
  }, text.styles({
    target: 'banner.description',
    fallback: 'normal.default'
  })), {}, {
    minWidth: function minWidth(_ref7) {
      var token = _ref7.token;
      return token('banner.description.minWidth', '20rem');
    }
  })
});
export function Banner(_ref8) {
  var _context;

  var title = _ref8.title,
      strong = _ref8.strong,
      description = _ref8.description,
      _ref8$actions = _ref8.actions,
      actions = _ref8$actions === void 0 ? [] : _ref8$actions,
      Icon = _ref8.Icon,
      handleClose = _ref8.handleClose,
      children = _ref8.children,
      rest = _objectWithoutProperties(_ref8, _excluded);

  var s = useStyles(defaultStyles);
  var token = useToken();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasGrown = _useState2[0],
      setHasGrown = _useState2[1]; // Heh... Javascript is fun


  var containerRef = useResizeObserver(function (_ref9) {
    var target = _ref9.target;

    // HACK: This feels just a little bit wrong and can fail when
    // some customisation is applied to these banners and the minHeight
    // is not adjusted accordingly, or the minHeight is removed entirely
    var minHeight = _parseInt(getComputedStyle(target).minHeight.replace('px', ''));

    var currentHeight = target.offsetHeight;

    if (currentHeight > minHeight) {
      setHasGrown(true);
    } else {
      setHasGrown(false);
    }
  }, []);

  var leftMargin = _concatInstanceProperty(_context = "calc(".concat(token('banner.icon.size', token('icon.size.m')), " + ")).call(_context, token('spacing.s'), ")");

  var minHeight = hasGrown ? token('banner.compact.minHeight', '7.4rem') : token('banner.minHeight', '5.8rem');
  var paddingTop = hasGrown ? token('banner.compact.padding.top', token('spacing.m')) : token('banner.padding.top', token('spacing.xs'));
  var paddingRight = hasGrown ? token('banner.compact.padding.right', token('spacing.m')) : token('banner.padding.right', token('spacing.m'));
  var paddingBottom = hasGrown ? token('banner.compact.padding.bottom', token('spacing.m')) : token('banner.padding.bottom', token('spacing.xs'));
  var paddingLeft = hasGrown ? token('banner.compact.padding.left', token('spacing.m')) : token('banner.padding.left', token('spacing.m'));
  var hasActions = actions.length > 0;
  return /*#__PURE__*/React.createElement(Box, _extends({}, s('container', {
    strong: strong
  }), {
    ref: containerRef,
    flexDirection: "row",
    justifyContent: "space-between",
    pt: paddingTop,
    pr: paddingRight,
    pb: paddingBottom,
    pl: paddingLeft,
    style: {
      minHeight: minHeight
    }
  }, rest), /*#__PURE__*/React.createElement(Box, {
    flex: 1,
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    spacing: token('spacing.s')
  }, /*#__PURE__*/React.createElement(Box, {
    alignItems: "flex-start"
  }, Icon && /*#__PURE__*/React.createElement(Box, _extends({}, s('icon'), {
    alignItems: "center",
    justifyContent: "center",
    mr: token('spacing.s')
  }), /*#__PURE__*/React.createElement(Icon, {
    size: "m"
  })), /*#__PURE__*/React.createElement(Box, {
    flexDirection: "column"
  }, title && /*#__PURE__*/React.createElement("span", s('title'), title), /*#__PURE__*/React.createElement(Box, {
    flex: 1
  }, /*#__PURE__*/React.createElement("span", s('description'), description || children)))), hasActions && /*#__PURE__*/React.createElement(Box, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    alignItems: "center",
    ml: Icon && hasGrown ? leftMargin : 0
  }, /*#__PURE__*/React.createElement(ButtonGroup, {
    end: !hasGrown,
    sx: token('spacing.s'),
    flexWrap: "wrap",
    flexDirection: hasGrown ? 'row' : 'row-reverse'
  }, _mapInstanceProperty(actions).call(actions, function (_ref10, index) {
    var _Button;

    var label = _ref10.label,
        onClick = _ref10.onClick,
        Button = _ref10.Button;
    Button = (_Button = Button) !== null && _Button !== void 0 ? _Button : index === 0 ? OutlineButton : GhostButton;
    return /*#__PURE__*/React.createElement(Button, {
      key: index,
      onClick: onClick
    }, label);
  }))))), handleClose && /*#__PURE__*/React.createElement(Box, {
    alignItems: hasGrown ? 'flex-start' : 'center',
    ml: token('spacing.s')
  }, /*#__PURE__*/React.createElement(TintIconButton, {
    size: "xs",
    Icon: CrossSmall,
    onClick: handleClose
  })));
}
export default Banner;